
const state = {
    userInfo: {}
}
const mutations = {
    setUserInfo(state, val) {
        state.userInfo = val
    }
}
const actions = {}
const getters = {
    userInfo: (state) => state.userInfo,
}

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters,
}